import React from 'react';
import PropTypes from 'prop-types';
import soundEnabledSrc from '@chama/statics/assets/svg/siren-icon.svg';
import soundDisabledSrc from '@chama/statics/assets/svg/siren-muted-icon.svg';

const propTypes = {
  isMuted: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

const OrderSoundButton = ({ isMuted, onClick }) => {
  if (isMuted) {
    return (
      <button className="u__normalize_button" onClick={onClick}>
        <img src={soundDisabledSrc} className="OrderSoundButton__icon" alt="sound enabled" />
      </button>
    );
  }

  return (
    <button className="u__normalize_button" onClick={onClick}>
      <img src={soundEnabledSrc} className="OrderSoundButton__icon" alt="sound muted" />
    </button>
  );
};

OrderSoundButton.propTypes = propTypes;

export default OrderSoundButton;



// WEBPACK FOOTER //
// ../ui-components/components/OrderSoundButton/index.jsx